/**
 * Menu configuration for the user portal sidebar
 * Centralized menu item definitions to eliminate duplication
 */

export const menuItems = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/dashboard',
    type: 'link'
  },
  {
    key: 'license',
    label: 'License History',
    icon: 'how_to_reg',
    path: '/license-history',
    type: 'link'
  },
  {
    key: 'payments',
    label: 'Payments',
    icon: 'credit_card',
    path: '/payments',
    type: 'link'
  },
  {
    key: 'lead-scientist-assignments',
    label: 'Assignment Requests',
    icon: 'assignment_ind',
    path: '/lead-scientist-assignments',
    type: 'link'
  },
  {
    key: 'account-settings',
    label: 'Account Settings',
    icon: 'settings',
    path: '/account-settings',
    type: 'link'
  },
  {
    key: 'logout',
    label: 'Logout',
    icon: 'logout',
    path: '/logout',
    type: 'link'
  }
];

export const SIDEBAR_BACKGROUND_COLOR = '#00264C';
